"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUMMARIES_API_TIMEOUT = exports.SUMMARY_QUERY_LANGUAGES = exports.SUMMARY_QUERY_ELEMENTS = void 0;
exports.SUMMARY_QUERY_ELEMENTS = {
    USPS: 'usps',
    REVIEW: 'review',
    IMAGE: 'image',
    IMAGES: 'images',
    DISPLAY_NAME: 'displayName'
};
exports.SUMMARY_QUERY_LANGUAGES = {
    EN: 'en',
};
exports.SUMMARIES_API_TIMEOUT = 5000;
//# sourceMappingURL=properties.types.js.map